import base from 'app/default/style';
import {fromJS} from 'immutable';

export default ({globalVariables = {}} = {}) => {
    const nested = fromJS(base({globalVariables}));
    const dropDownArrowGreen = globalVariables.$dropDownArrowGreen;

    return nested.mergeDeep({
        SignupForm: {
            height: 'auto',
            minHeight: '100%',
            position: 'relative'
        },
        '@global': {
            'html': {
                'overflow-x': 'hidden',
                margin: 0,
                padding: 0,
                height: '100%',
            },
            'body': {
                background: '#f0f1f2',
                'overflow-x': 'hidden',
                'font-family': 'Lato',
                'min-height': '100%',
                position: 'relative',
                '&:before': {
                    content: '""',
                    height: '100%',
                    display: 'inline-block',
                    position: 'absolute',
                    top: 0,
                    background: '#dfdfe1',
                    width: '100%',
                    marginLeft: '-50%',
                    transform: 'skew(-15deg)',
                    'z-index': '-1'
                },
                '& .content-wrapper': {
                    // 'padding-bottom': '80px',
                    '& .intro-panel': {
                        position: 'relative',
                        overflow: 'hidden',
                        '@media (max-width: 1020px)': {
                            padding: '0 10px 0 10px !important',
                            '& .inner': {
                                padding: '20px !important',

                                '& p': {
                                    'margin-bottom': '0'
                                }
                            }
                        },
                        '@media (max-width: 510px)': {
                            width: '495px !important',
                        },
                        '&:before': {
                            'z-index': -1,
                            position: 'absolute',
                            content: '""',
                            left: '-33px',
                            width: '50%;',
                            top: '-103px',
                            height: '50px',
                            overflow: 'hidden',
                            'max-width': '50%',
                            background: 'transparent',
                            'box-shadow': '0 40px 25px 30px #000000',
                            transform: 'rotate(-2deg)',
                            opacity: '0.20'
                        },
                        '&:after': {
                            'z-index': -1,
                            position: 'absolute',
                            content: '""',
                            left: 'auto',
                            right: '-33px',
                            width: '50%;',
                            top: '-103px',
                            height: '50px',
                            overflow: 'hidden',
                            'max-width': '50%',
                            background: 'transparent',
                            'box-shadow': '0 40px 25px 30px #000000',
                            transform: 'rotate(2deg)',
                            opacity: '0.20'
                        },
                        '& .inner': {
                            width: '470px',
                            margin: 'auto',
                            'margin-top': '20px',
                            'margin-bottom': '5px',
                            padding: '20px 30px 10px 30px',
                            'box-shadow': '0px 2px 3px #c6c6c6 !important',
                            backgroundColor: '#fff',
                            'border-radius': '4px',
                            '& h2': {
                                'font-family': 'Montserrat !important',
                                'font-style': 'italic !important',
                                'font-weight': '400 !important',
                                'font-size': '18px !important',
                                'line-height': '20px !important',
                                'padding-bottom': '5px',
                                'margin-bottom': '15px',
                                'border-bottom': 'solid 1px #0485C2',
                                'margin-top': '0'
                            },
                            '& p': {
                                'font-family': 'Lato !important',
                                'font-style': 'normal !important',
                                'font-weight': '400 !important',
                                'font-size': '14px !important',
                                'line-height': '20px !important',
                            },
                        },
                    },
                    '& .content-panel': {
                        position: 'relative',
                        'min-height': 'auto !important',
                        padding: '10px 10px 95px 10px !important',
                        display: 'block !important',
                        '& .panel-heading': {
                            'font-family': 'Montserrat !important',
                            'font-style': 'italic !important',
                            'font-weight': '700 !important',
                            'font-size': '35px !important',
                            'line-height': '38px !important',
                            'margin-top': '20px',
                            'margin-bottom': '30px',
                        },
                        '@media (max-width: 1020px)': {
                            width: '100% !important',
                            '& > div': {
                                width: '100% !important',
                                '& .panel': {
                                    width: '100% !important',
                                    '& .panel-heading': {
                                        'width': '100% !important'
                                    },
                                    '& .panel-body': {
                                        'width': '100% !important'
                                    }
                                }
                            },
                        },
                        '@media (max-width: 510px)': {
                            width: '495px !important',
                        },
                    },
                    '& .panel': {
                        'box-shadow': '0px 2px 3px #c6c6c6 !important',
                        padding: '15px'
                    }
                },
            },
        },
        Topbar: {
            backgroundColor: '#fff',
            padding: '0',
            height: '80px',
            position: 'relative',
            // 'overflow-x': 'hidden',
            'z-index': 999,
            '@media (max-width: 1020px)': {
                '& .inner': {
                    width: '100% !important'
                },
            },
            '@media (max-width: 510px)': {
                height: '120px',
                '& .logo': {
                    backgroundSize: '200px auto !important',
                    width: '100% !important',
                    backgroundPosition: 'top center !important',
                },
                '& .children': {
                    width: 'auto !important',
                    'margin': 'auto !important',
                    float: 'none !important',
                    padding: '0 10px 0 10px !important',
                    display: 'table',

                },
                '& .dropdown': {
                    height: '42px !important'
                },
                '& #LanguageSelector': {
                    margin: '5px 0 5px 0 !important'
                }
            },
            '@media (min-width: 511px) and (max-width: 545px)': {
                '& .logo': {
                    backgroundPosition: 'top left 20px !important',
                    backgroundSize: '200px auto !important',
                },
                '& .children': {
                    padding: '0 30px 0 30px !important'
                }
            },
            '@media (min-width: 546px) and (max-width: 1020px)': {
                '& .inner': {
                    width: '100% !important'
                },
                '& .logo': {
                    backgroundPosition: 'top left 20px !important',
                    backgroundSize: '200px auto !important',
                },
                '& .children': {
                    'margin-right': '-10px !important'
                }
            },
            '& .inner': {
                width: '1020px',
                margin: 'auto',
            },
            '& .logo': {
                margin: '28px 0 0 0',
                width: '219px',
                backgroundSize: 'contain',
                backgroundPosition: 'top center',
            },
            '& .children': {
                backgroundColor: '#3e3d46',
                margin: '0',
                padding: '0 50px 0 50px',
                backgroundSize: 'contain',
                backgroundPosition: 'top center',
                transform: 'skew(-15deg)',
                '& .dropdown': {
                    height: '80px',
                    '& #LanguageSelector': {
                        background: 'transparent',
                        border: 'none',
                        margin: '25px 0 0 0',
                        transform: 'skew(15deg)',
                        '& .dropdown-label': {
                            'overflow-x': 'visible',
                            'min-width': '200px',
                        },
                        '& .title': {
                            color: '#fff',
                            'padding-right': '30px;',
                            'min-width': '200px',
                            background: 'url("'+dropDownArrowGreen+'") no-repeat right center',
                        },
                        '& .caret': {
                            display: 'none'
                        },
                    },
                    '& .dropdown-menu': {
                        left: '37px',
                        transform: 'skew(15deg)'
                    },
                },
            },
        },
        Bottombar: {
            backgroundColor: '#0485C2',
            'box-shadow': '0px -2px 3px #c6c6c6',
            padding: '30px 0 30px 0',
            height: 'auto',
            position: 'absolute',
            width: '100%',
            bottom: '0',
            '& p': {
                margin: '0',
                color: '#fff',
                'text-align': 'center',
                '& a': {
                    margin: '0',
                    color: '#fff',

                },
            },
        },
        BigError: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '100%'
        }
    }).toJS();
};
